export default "__VITE_ASSET__C8rPBR1S__"